import PropTypes from 'prop-types';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from 'gsap/SplitText';
import { useGSAP } from "@gsap/react";
import { useRef, useState } from 'react';

gsap.registerPlugin(useGSAP, ScrollTrigger, SplitText);

export function AnimationDigital({ containerClassName }) {
    const text = 'Digital';
    const containerClasses = (containerClassName) ? `animation--digital ${containerClassName}` : 'animation--digital';
    const containerRef = useRef(null);
    const cursorRef = useRef(null);
    const [ displayText, setDisplayText ] = useState('');

    useGSAP(() => {
        const container = containerRef.current;
        const cursor = cursorRef.current;

        // On sécurise l'appel au hook
        if(!container || !cursor) return;

        // On définit la timeline principale
        const tl = gsap.timeline({
            paused: true,
            onUpdate: function() {
                const progress = this.progress();
                const charsToShow = Math.floor(progress * text.length);
                setDisplayText(text.substring(0, charsToShow));
            },
            onReverseComplete: function() {
                setDisplayText(''); // Reset du texte quand on revient au début
            }
        });

        // Animation du texte, obligatoire sinon l'animation ne fonctionne pas
        tl.to({}, {});

        // Animation du cursor
        gsap.to(cursor, {
            opacity: 0,
            duration: 0.5,
            repeat: -1,
            yoyo: true,
            ease: 'power2.inOut'
        });

        // ScrollTrigger
        ScrollTrigger.create({
            trigger: container,
            start: "top center",
            end: "bottom-=60% center",
            animation: tl,
            toggleActions: "play reverse play reverse",
            scrub: true,
        });

    }, { scope: containerRef });

    return (
        <div ref={containerRef} id="Digital_HTML" aria-label="digital" className={containerClasses}>
            <div className="">
                <p aria-hidden="true">&lt;ContentTitle</p>
                <p>
                    <span aria-hidden="true">Text=</span>
                    <span aria-hidden="true" className="blank-space">&nbsp;</span>
                    <span aria-hidden="true" className="writted-text">{displayText}</span>
                    <span ref={cursorRef} className="animated-cursor"></span>
                </p>
                <p aria-hidden="true">
                    <span>integration=&quot;code&quot; /&gt;</span><br/>
                    <span className="indent--triple">&lt;Content q=&#123;5&#125; /&gt;</span><br/>
                    <span className="indent--double">&lt;/&gt;</span><br/>
                    <span className="indent">&#41;</span><br/>
                    <span>&#125;</span>
                </p>
            </div>
        </div>
    )
}

AnimationDigital.propTypes = {
    id: PropTypes.string.isRequired,
    containerClassName: PropTypes.string,
}

export default AnimationDigital;
